import styled from "styled-components";
export const SignInPar = styled.h3`
  color: var(--Gray-Gray-900, #ed663be0);
  text-align: center;
  font-family: Rubic;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
export const SignInNotes = styled.p`
  color: var(--Gray-Gray-500, #a1a5b7);
  text-align: center;
  font-family: Rubic;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 100% */
`;
export const SignInButton = styled.button`
  width: 100%;
  height: 40px;
  text-align: center;
  background: var(--78-a-22-e, #ed663be0);
  border: none;
  color: #fff;
  border-radius: 6px;
`;
export const AlreadyHave = styled.p`
  color: var(--Gray-Gray-500, #a1a5b7);
  text-align: center;
  font-family: Rubic;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
`;
export const LoginTerms = styled.div`
  color: var(--231-f-20, #231f20);
  font-family: Rubic;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px;
  display: flex;
  justify-content: space-around;
`;
export const LoginContainer = styled.div`
  max-width: 390px;
  margin: 10% auto;
`;
